import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import slugify from "slugify";
import { OutlineEye, OutlineEyeOff, SearchIcon2 } from "./assets";
import HeroSlider from "./HeroSlider";
import { fetchFaqsItems } from "./redux/slices/FaqsThunks";
import {
  createFavouriteVendorItem,
  fetchFavouriteVendorsItems,
  removeFavouriteVendor,
} from "./redux/slices/FavouriteVendorsThunks";
import { fetchFeaturedvendorsItems } from "./redux/slices/FeaturedvendorsThunks";
import { fetchIndustrysectorparentItems } from "./redux/slices/IndustrysectorcategoriesThunks";
import { updateMembersItem } from "./redux/slices/MembersThunks";
import {
  fetchVendorItems,
  SearchVendorItems,
} from "./redux/slices/VendorThunks";
import Navbar from "./shared/Navbar";
import { generateSlugMap, scrollToTop } from "./utils/func";

const priceRanges = [
  { value: "0-500", label: "0 - 500" },
  { value: "500-1000", label: "500 - 1000" },
  { value: "1000-5000", label: "1000 - 5000" },
  { value: "5000-10000", label: "5000 - 10000" },
];

export default function Referralsone() {
  const navigate = useNavigate();
  const ref = useRef(null);
  const { id: vendorId } = useParams();
  const location = useLocation();
  const [selectedSortOption, setSelectedSortOption] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIndustry, setselectedIndustry] = useState("");
  const [selectedRange, setSelectedRange] = useState("");
  const member = JSON.parse(localStorage.getItem("member"));
  const [hidden, setHidden] = useState(member?.hide_vendor_banner);
  const dispatch = useDispatch();
  const vendorsItems = useSelector((state) => state.vendor.items);
  const [featuredVendorsWithDetails, setFeaturedVendorsWithDetails] = useState(
    []
  );
  const favouriteVendors = useSelector((state) => state.favouriteVendors.items);
  const { user, loading, hasChecked } = useSelector((state) => state.auth);
  const industrysectorparent = useSelector(
    (state) => state.industrysectorparent.items || []
  );

  const scrollToComponent = () => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const slugMap = useMemo(() => generateSlugMap(vendorsItems), [vendorsItems]);

  useEffect(() => {
    dispatch(fetchFaqsItems());
    dispatch(fetchVendorItems());
    dispatch(fetchIndustrysectorparentItems());
    dispatch(fetchFavouriteVendorsItems());

    const fetchFeaturedWithVendorDetails = async () => {
      try {
        const featuredResult = await dispatch(fetchFeaturedvendorsItems());
        const featuredItems = featuredResult.payload;
        const filtered = featuredItems.filter((v) => {
          const status = v.vendor_id.vendor_profile_status;
          return status !== "Freeze" && status !== "Draft";
        });
        setFeaturedVendorsWithDetails(filtered);
      } catch (error) {
        console.error("Failed to load featured vendors with details:", error);
      }
    };

    fetchFeaturedWithVendorDetails();
  }, []);

  const isVendorFavourite = (vendorId) => {
    if (!favouriteVendors || !Array.isArray(favouriteVendors)) {
      return false;
    }

    return favouriteVendors.some((fav) => {
      return fav?.vendor_id?._id === vendorId;
    });
  };
  const toggleFavourite = async (vendorId) => {
    try {
      if (!user) {
        localStorage.setItem(
          "postLoginAction",
          JSON.stringify({ action: "favourite", vendorId })
        );

        window.location.href = `${process.env.REACT_APP_AUTH_BASE_URL}`;
        return;
      }

      if (isVendorFavourite(vendorId)) {
        await dispatch(removeFavouriteVendor(vendorId)).unwrap();
      } else {
        await dispatch(createFavouriteVendorItem({ vendorId })).unwrap();
      }

      dispatch(fetchFavouriteVendorsItems());
    } catch (err) {
      console.error("Failed to toggle favourite:", err);
    }
  };

  const toggleBanner = async () => {
    const newStatus = !hidden;
    setHidden(newStatus);
    if (!member?._id) return;
    const data = {
      _id: member._id,
      hide_vendor_banner: newStatus,
    };

    try {
      await dispatch(updateMembersItem(data)).unwrap();
    } catch (e) {
      console.error("Error updating member:", e);
      setHidden(!newStatus);
    }
  };
  const sortedVendors = [...featuredVendorsWithDetails].sort(
    (a, b) => a.position - b.position
  );
  useEffect(() => {
    if (user) {
      const params = new URLSearchParams(location.search);
      const action = params.get("action");
      const vendorId = params.get("vendorId");

      if (action === "favourite" && vendorId) {
        dispatch(createFavouriteVendorItem({ vendorId }))
          .unwrap()
          .then(() => dispatch(fetchFavouriteVendorsItems()))
          .finally(() => {
            window.history.replaceState({}, "", location.pathname);
          });
      }
    }
  }, [user, location.search, dispatch]);

  return (
    <>
      <Navbar />
      <RootWrapperReferralsone>
        {hidden && (
          <HiddenSectionWrapper1>
            <HiddenSectionWrapper>
              <HiddenWrapper>
                <TheVendorsMarketeersLoveToRecommend hidden={hidden}>
                  The vendors you love to recommend
                </TheVendorsMarketeersLoveToRecommend>
                <HideButton onClick={() => toggleBanner()}>
                  <Icon
                    src={hidden ? OutlineEye : OutlineEyeOff}
                    alt="Eye Icon"
                  />{" "}
                  {hidden ? "Show Section" : "Hide Section"}
                </HideButton>
              </HiddenWrapper>
            </HiddenSectionWrapper>
          </HiddenSectionWrapper1>
        )}
        {!hidden && (
          <Section>
            <Wrapper>
              <Frame2025>
                <HideButton
                  onClick={() => toggleBanner()}
                  position="absolute"
                  top="20px"
                  right="336px"
                >
                  <Icon
                    src={hidden ? OutlineEye : OutlineEyeOff}
                    alt="Eye Icon"
                  />{" "}
                  {hidden ? "Show Section" : "Hide Section"}
                </HideButton>
              </Frame2025>
              <SectionBanner2>
                <Frame19>
                  <Left_0001>
                    <Frame6>
                      <TheVendorsMarketeersLoveToRecommend>
                        The vendors you love to recommend
                      </TheVendorsMarketeersLoveToRecommend>
                      <AdvocateReferEarn>Rewarding Referrals</AdvocateReferEarn>
                    </Frame6>
                    <Frame5>
                      <PRTNR.Button
                        onClick={() => {
                          scrollToComponent();
                        }}
                      >
                        View Cash Rewards
                      </PRTNR.Button>
                    </Frame5>
                  </Left_0001>
                  <Right>
                    <HeroSlider />
                    {/* <Image_0002 src={VendorHero} alt="Hero" /> */}
                  </Right>
                </Frame19>
              </SectionBanner2>
            </Wrapper>
          </Section>
        )}
        <Section_0001>
          <Wrapper>
            <ContentBlock1>
              <Content>
                <EarningCashForMakingReferralsIsEasierThanEver>
                  Featured Vendors
                </EarningCashForMakingReferralsIsEasierThanEver>
                <DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
                  Only vendors that our team of experts know, like and trust are
                  invited to join Paartner
                </DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
              </Content>
            </ContentBlock1>
          </Wrapper>
        </Section_0001>
        <Section_0002>
          <Wrapper>
            <SectionFeaturedCategoreis>
              <TopRow>
                {sortedVendors
                  .filter((_, index) => index < 2) // first 2 go to top row
                  .map((item) => (
                    <TopCard key={item._id}>
                      <PRTNR.DealCardMore
                        title={item.vendor_id?.short_description}
                        reward={item.vendor_id?.reward}
                        badgeType={item.vendor_id?.vendor_badge}
                        logoUrl={item.vendor_id?.compay_logo}
                        thumpnailUrl={item.vendor_id?.website_thumbnail}
                        onClick={() => {
                          navigate(
                            `/vendors/${slugify(item.vendor_id?.company_name, {
                              lower: true,
                              strict: true,
                              state: { item },
                            })}`
                          );
                          scrollToTop();
                        }}
                        onFavorite={() => toggleFavourite(item.vendor_id._id)}
                        isFavorite={isVendorFavourite(item.vendor_id._id)}
                      />
                    </TopCard>
                  ))}
              </TopRow>

              <BottomRow>
                {sortedVendors
                  .filter((_, index) => index >= 2 && index < 5) // next 3 go to bottom row
                  .map((item) => (
                    <PRTNR.DealCardMore
                      title={item.vendor_id?.short_description}
                      reward={item.vendor_id?.reward}
                      badgeType={item.vendor_id?.vendor_badge}
                      logoUrl={item.vendor_id?.compay_logo}
                      thumpnailUrl={item.vendor_id?.website_thumbnail}
                      onClick={() => {
                        navigate(
                          `/vendors/${slugify(item.vendor_id?.company_name, {
                            lower: true,
                            strict: true,
                            state: { item },
                          })}`
                        );
                        scrollToTop();
                      }}
                      onFavorite={() => toggleFavourite(item.vendor_id._id)}
                      isFavorite={isVendorFavourite(item.vendor_id._id)}
                    />
                  ))}
              </BottomRow>
            </SectionFeaturedCategoreis>
          </Wrapper>
        </Section_0002>

        <Section_0001>
          <Wrapper>
            <Section_0004>
              <Frame51 ref={ref}>
                <VendorCategories>Vendor Categories</VendorCategories>
                <Frame50>
                  <FrameWrapper1>
                    <SelectWrapper width={"220px"}>
                      <PRTNR.Input
                        placeholder={"Search"}
                        leftIcon={SearchIcon2}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </SelectWrapper>
                    <SelectWrapper width={"200px"}>
                      <PRTNR.Select
                        placeholder="Select Industry"
                        value={selectedIndustry}
                        onChange={(option) =>
                          setselectedIndustry(option.target.value)
                        }
                        options={
                          industrysectorparent?.map((sector) => ({
                            value: sector.sector_name,
                            label: sector.sector_name,
                          })) || []
                        }
                      />
                    </SelectWrapper>
                    <SelectWrapper width={"220px"}>
                      <PRTNR.Select
                        placeholder="Select Reward Range"
                        value={selectedRange}
                        onChange={(option) =>
                          setSelectedRange(option.target.value)
                        }
                        options={priceRanges}
                      />
                    </SelectWrapper>
                    <SelectWrapper>
                      <PRTNR.Select
                        placeholder="Sort by"
                        value={selectedSortOption}
                        onChange={(option) =>
                          setSelectedSortOption(option.target.value)
                        }
                        options={[
                          { value: "asc", label: "Vendor Name (A-Z)" },
                          { value: "desc", label: "Vendor Name (Z-A)" },
                        ]}
                      />
                    </SelectWrapper>
                  </FrameWrapper1>
                  <FrameWrapper>
                    <PRTNR.Button
                      variant="gray"
                      onClick={() => {
                        setselectedIndustry("");
                        setSelectedSortOption("");
                        setSearchTerm("");
                        setSelectedRange("");
                        dispatch(fetchVendorItems());
                      }}
                    >
                      Clear
                    </PRTNR.Button>

                    <PRTNR.Button
                      onClick={() => {
                        let rewardMin = "";
                        let rewardMax = "";

                        if (selectedRange) {
                          [rewardMin, rewardMax] = selectedRange.split("-");
                        }
                        dispatch(
                          SearchVendorItems({
                            companyName: searchTerm,
                            sortOrder: selectedSortOption,
                            selectedIndustry: selectedIndustry,
                            rewardMax,
                            rewardMin,
                          })
                        );
                      }}
                    >
                      Apply Filter
                    </PRTNR.Button>
                  </FrameWrapper>
                </Frame50>
              </Frame51>
              <Frame47_0001>
                {vendorsItems.map((vendor) => {
                  const slug = Object.keys(slugMap).find(
                    (key) => slugMap[key] === vendor._id
                  );

                  return (
                    <DealCardWrapper>
                      <PRTNR.DealCard
                        key={vendor._id}
                        title={vendor?.short_description}
                        reward={vendor?.reward}
                        badgeType={vendor?.vendor_badge}
                        logoUrl={`${vendor?.compay_logo}`}
                        // onClick={() => {
                        //   navigate(`/vendors/${vendor?._id}`);
                        // }}
                        onClick={() => {
                          navigate(`/vendors/${slug}`, { state: { vendor } });
                          scrollToTop();
                        }}
                        isFavorite={isVendorFavourite(vendor._id)}
                        onFavorite={() => {
                          toggleFavourite(vendor._id);
                        }}
                      />
                    </DealCardWrapper>
                  );
                })}
              </Frame47_0001>
            </Section_0004>
          </Wrapper>
        </Section_0001>
      </RootWrapperReferralsone>
    </>
  );
}

const RootWrapperReferralsone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  /* min-height: 100vh; */
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  z-index: 2;
  padding-top: 89px;

  @media (max-width: 768px) {
    padding-top: 84px;
  }
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(248, 250, 252);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding-inline: clamp(1rem, 5vw, 3.75rem);
  padding-bottom: clamp(1rem, 5vw, 3.75rem);
  flex-shrink: 0;
  position: relative;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;
const Frame2025 = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 60px;
  align-items: center;
  width: 100%;
`;
const HiddenSectionWrapper1 = styled.div`
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  background: #f8fafc;
  width: 100%;
  padding: 16px 60px;
  @media (max-width: 1024px) and (min-width: 768px) {
    padding: 16px 16px;
  }

  @media (max-width: 767px) {
    padding: 16px 16px;
  }
`;
const HiddenSectionWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;
const HiddenWrapper = styled.div`
  display: flex;

  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
`;
const HideButton = styled.button`
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 32px;
  border: none;
  background: var(--Color-mics-acent-color-1---Light, rgba(89, 84, 222, 0.1));
  color: var(--Color-Text-Gray, #64748b);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

const SectionBanner2 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame19 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  height: 420px;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: column;
    height: 100%;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    height: 100%;
    gap: 40px;
  }
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 48px;
  width: 600px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame6 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const TheVendorsMarketeersLoveToRecommend = styled.span`
  text-overflow: ellipsis;
  font-size: ${(props) =>
    props.hidden ? "clamp(1rem, 2vw, 24px)" : "clamp(2.125rem, 5vw, 68px)"};
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -2px;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
  background: linear-gradient(90deg, #da45d4, #6f7eff, #7dbded);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: block;
`;

const AdvocateReferEarn = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(20px, 5vw, 24px);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame5 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 409px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  align-self: stretch;
  width: 600px;
  box-sizing: border-box;
  flex-shrink: 0;
  position: relative;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
    display: none;
  }
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: clamp(1rem, 5vw, 3.75rem);
  flex-shrink: 0;
`;

const ContentBlock1 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 24px;
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
`;

const EarningCashForMakingReferralsIsEasierThanEver = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(24px, 2.5vw, 48px);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(16px, 2.5vw, 20px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Section_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding-inline: clamp(1rem, 5vw, 3.75rem);
  flex-shrink: 0;
`;

const SectionFeaturedCategoreis = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const GridRow = styled.div`
  display: grid;
  gap: 20px;
  width: 100%;
  max-width: 1200px;
`;

const TopRow = styled(GridRow)`
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr); // 2 columns on tablets
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr; // 1 column on mobile
  }
`;
const TopCard = styled.div`
  flex: 0 0 50%;
`;

const BottomRow = styled(GridRow)`
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr); // 2 columns on tablets
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr; // 1 column on mobile
  }
`;

const Section_0004 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame51 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const VendorCategories = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame50 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  gap: 16px;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
const FrameWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 333px;
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
`;
const FrameWrapper1 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 70%;

  @media (max-width: 1024px) {
    width: 100%;
    flex-wrap: wrap;
  }

  @media (max-width: 480px) {
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
  }
`;
const SelectWrapper = styled.div`
  max-width: ${(props) => (props.width ? props.width : "159px")};
  width: 100%;
`;

const Frame47_0001 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr); // default 4 columns
  gap: 32px;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr); // 2 columns on tablets
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr); // 1 column on mobile
  }
`;

const DealCardWrapper = styled.div`
  width: 220px;
  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;
